import { render, staticRenderFns } from "./OfertasOmil.vue?vue&type=template&id=1715ef97&scoped=true"
import script from "./OfertasOmil.vue?vue&type=script&lang=ts"
export * from "./OfertasOmil.vue?vue&type=script&lang=ts"
import style0 from "./OfertasOmil.vue?vue&type=style&index=0&id=1715ef97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1715ef97",
  null
  
)

export default component.exports